/** @format */

export const DCSG_CONSTANTS: any = {
	analyticsReporting: {
		boolean: {
			true: 'true',
			false: 'false'
		},
		dym: {
			auto: 'DYM Auto',
			clicked: 'DYM Clicked'
		},
		pageType: {
			home: 'Home',
			category: 'Category',
			family: 'Family',
			search: 'Search',
			product: 'Product Details',
			cart: 'Cart',
			checkout: 'Checkout',
			'order.confirmation': 'OrderConfirmation'
		},
		replacementType: {
			addition: 'Addition',
			replacement: 'Replacement'
		},
		searchEmptyResults: {
			recordSetTotal: '',
			catalogEntryView: [],
			searchDetails: {
				DYMTerm: '',
				DYMType: '',
				searchTerm: '',
				replacementTerm: '',
				searchType: ''
			}
		},
		searchType: {
			keyword: 'Keyword',
			suggestedKeyword: 'Suggested Keyword',
			suggestedProduct: 'Suggested Product',
			suggestedBrand: 'Suggested Brand',
			pdpBrandClick: 'PDP Brand Click',
			suggestedResources: 'Suggested Resources',
			suggestedHistory: 'Suggested History',
			suggestedCategory: 'Suggested Category',
			searchByProductID: 'Search by ProductID',
			redirect: 'Redirect'
		},
		yesOrNo: {
			Y: 'Y',
			N: 'N'
		}
	},
	attributes: {
		identifiers: {
			badge: '4298',
			freeReturnsEligible: '4493'
		}
	},
	basePath: 'dcsg-ngx-ecommerce',
	cookies: {
		auth: {
			expiration: {
				value: 30,
				unit: 'days'
			}
		},
		cart: {
			contents: {
				cookieName: 'DCSG-CART'
			}
		},
		checkout: {
			contents: {
				cookieName: 'DCSG-CHECKOUT'
			},
			xContents: {
				cookieName: 'X-DCSG-CHECKOUT'
			}
		}
	},
	defaultCurrency: 'USD',
	defaultStoreSearchRadius: 100,
	defaultNumberOfStores: 5,
	errorHandling: {
		messagePrefixes: {
			global: {
				client: 'APPLICATION_ERROR:CLIENT_ERROR: ',
				data: 'APPLICATION_ERROR:DATA_ERROR: ',
				generic: 'APPLICATION_ERROR:GENERIC_ERROR: ',
				http: 'APPLICATION_ERROR:HTTP_ERROR: ',
				offline: 'APPLICATION_ERROR:OFFLINE_ERROR: ',
				timeout: 'TIMEOUT_ERROR: '
			}
		}
	},
	homr: {
		acceptedHeaders: [
			'dsg_range',
			'dih',
			'audience',
			'draft',
			'preview',
			'previewdate',
			'whereabouts',
			'segment'
		],
		stateKeyExceptions: [
			'disruptor',
			'ticker',
			'header',
			'footer',
			'deal-drawer',
			'calendar',
			'home',
			'static'
		],
		aosPageTypes: ['disruptor', 'footer', 'header', 'home', 'modal', 'ticker', 'checkout'],
		previewKey: 'williamgoats'
	},
	localStorage: {
		auth: {
			expiration: {
				value: 30,
				unit: 'days'
			}
		}
	},
	maxAppWidth: 1600,
	maxApiRetries: 3,
	paginationSize: {
		familyAndSearch: 48
	},
	productRecs: {
		timeout: 10000
	},
	searchMaxLength: 75,
	storeNumberUrl:
		'https://ngstorelocationlb.dcsg.com/NGStoreLocationWS/StoreLocationLookup.svc/json/GetStoreInformation',
	timeouts: {
		default: 20000,
		xxshort: 2000,
		xshort: 5000,
		short: 10000,
		medium: 30000,
		long: 60000
	},
	xProperties: {
		groupingLogicEnable: 'GROUPINGLOGIC_ENABLED'
	},
	baseImagePath: 'https://images.dickssportinggoods.com/marketing/',
	baseProductImagePath: 'https://dks.scene7.com/is/image/',
	imageUnavailable: 'https://images.dickssportinggoods.com/marketing/productImageUnavailable.jpg',
	imageUnavailableResized:
		'https://dks.scene7.com/is/image/GolfGalaxy/productImageUnavailable?wid=252&hei=252',
	minQtyAlert: {
		// message: 'You have selected the quantity which is less than the minimum limit for this product. The quantity has been adjusted for you.'
		message: 'The minimum quantity for this product option is'
	},

	maxQtyAlert: {
		// message: 'You have exceeded the maximum limit on the quantity for this product. The quantity has been adjusted for you.'
		message: 'The maximum quantity for this product option is'
	}
};
